<template>
  <v-row justify="center">
    <div class="gewerbe-confirm dmb-form-text">

      <div class="ueber primary--text pt-10 pb-6">Vielen Dank für Ihren Antrag!</div>

      <div class="muchtext">Ihr Antrag ist am
        <strong>{{ germanDate }}</strong> um
        <strong>{{ germanTime }} Uhr</strong> bei der DMB Rechtsschutz eingegangen und wird umgehend bearbeitet.
        Bis zur Policierung ist der Antrag mit der unten genannten Vorgangsnummer in der Kundenverwaltung unter <router-link to="/offeneAntraege" target="_blank">offene Anträge</router-link>
        jederzeit für Sie abrufbar.</div>

      <div>
        <br>
        <strong>Vorgangsnummer: {{ angebotsnummer }}</strong>
        <br>
        <br>
      </div>

      <div class="muchtext">Nach der Policierung befindet sich der Versicherungsvertrag in der Kundenverwaltung unter <router-link to="/bestand" target="_blank">Bestandsverträge</router-link>.</div>
        <br>
      <div class="muchtext">
        <span>
            Bei Abschluss lagen dem Kunden die derzeit gültigen
            <template v-if="arbLink">
              <a :href="arbLink + '#page=3&zoom=100'"
                 target="_blank">Allgemeinen Vertragsinformationen</a> und die
              <a :href="arbLink"
                 target="_blank">ARB 2024</a>
            </template>
            vor.
          </span>
        <br>
        <br> Bei Fragen zum Antrag wenden Sie sich bitte an unseren Maklerservice unter 
        <span class="nobreak"><a href="tel:+492213763892">(+49) 02 21 / 37 638 - 92</a></span> oder 
        <span class="nobreak"><a href="mailto:maklerservice@dmb-rechtsschutz.de">maklerservice@dmb-rechtsschutz.de</a></span>. 
        Wir sind gerne für Sie da und freuen uns auf die weiterhin gute Zusammenarbeit!
        <br>
        <br>

      </div>

      <v-row no-gutters justify="center">
        <v-btn :href="pdflink"
               target="_blank"
               color="primary"
               class="standard-button">Antrag herunterladen&nbsp;
          <v-icon>file_download</v-icon>
        </v-btn>
      </v-row>

      <v-row no-gutters
             class="stepperbuttons">
        <v-btn color="primary"
               class="standard-button"
               @click="$router.go()">Neues Angebot Gewerbekunden
        </v-btn>
        <v-spacer />
        <v-btn color="primary"
               class="standard-button"
               @click="$router.push('/start')">Zur Start-Seite
        </v-btn>
      </v-row>

    </div>
  </v-row>

</template>
<script>
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";
import {API_URL_SERVER} from "@/helper/httpService";

export default {
  mixins: [twowayBinding, contentLoadingMixin(["ARB"])],
  computed: {
    ...mapTwoWay([
      'angebotsnummer',
      'submitTime',
      'pdfpfad'
    ], {}, 'gewerbe.vertrag'),
    germanTime() {
      return this.submitTime.split(" ")[1];
    },
    germanDate() {
      return this.submitTime.replace(",", "").split(" ")[0];
    },
    pdflink () {
      return API_URL_SERVER + this.pdfpfad + "?disposition=inline";
    },
    arbLink () {
      return this.ARB ? this.ARB.items[0].link : null;
    }
  }
};
</script>
<style>
.gewerbe-confirm {
  max-width: 768px !important;
}

.gewerbe-confirm .muchtext {
  hyphens: manual;
}

.gewerbe-confirm span.nobreak {
  white-space: nowrap;
}
</style>
